import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthCheck } from "../components/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { api } from "../components/Api";

export default function AdminControl() {
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState("");
    const fileInputRef = useRef(null); // 🔹 Ref pour input caché

    useEffect(() => {
        checkToken();
    }, [checkToken]);

    const buttons = [
        { label: "Type", path: "/type-list", bg: "bg-blue-400", hover: "hover:bg-blue-500" },
        { label: "Sous-Type", path: "/subtype-list", bg: "bg-blue-400", hover: "hover:bg-blue-500" },
        { label: "License Carte", path: "/license-list", bg: "bg-purple-400", hover: "hover:bg-purple-500" },
        { label: "Rareté de Carte", path: "/rarity_card-list", bg: "bg-red-400", hover: "hover:bg-red-500" },
        { label: "Collection de Carte", path: "/collection-list", bg: "bg-red-400", hover: "hover:bg-red-500" },
        { label: "Extension de Carte", path: "/extension-list", bg: "bg-red-400", hover: "hover:bg-red-500" },
        { label: "", path: "/admin", bg: "bg-white-400", hover: "hover:bg-white-500" },
        { label: "", path: "/admin", bg: "bg-white-400", hover: "hover:bg-white-500" },
        { label: "Langue", path: "/language-list", bg: "bg-teal-400", hover: "hover:bg-teal-500" },
        { label: "Packaging", path: "/packaging-list", bg: "bg-teal-400", hover: "hover:bg-teal-500" },
        { label: "Type de Lien", path: "/linktype-list", bg: "bg-yellow-400", hover: "hover:bg-yellow-500" },
        { label: "Utilisateur", path: "/user-list", bg: "bg-orange-400", hover: "hover:bg-orange-500" },
    ];

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage("⚠️ Sélectionne un fichier avant de l’envoyer.");
            return;
        }

        setUploading(true);
        setMessage("");

        try {
            const formData = new FormData();
            formData.append("file", file);

            await api.post("/notice", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setMessage("✅ Fichier notice mis à jour avec succès !");
            setFile(null);
        } catch (error) {
            console.error(error);
            setMessage("❌ Erreur lors de l’envoi du fichier.");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="container mx-auto p-6">
            <div className="flex justify-between">
                <h1 className="text-2xl font-bold mb-6 dark:text-white">Panneau d’administration</h1>

                {/* 🧾 Section Upload Notice */}
                <div className="flex flex-col">
                    <div className="flex flex-row">
                        <h2 className="text-xl font-semibold mb-4 dark:text-white">Changer la notice : </h2>

                        {/* 🔹 Input caché */}
                        <input
                            type="file"
                            accept=".txt"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            className="hidden"
                        />

                        {/* 🔹 Bouton personnalisé */}
                        <button
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                            className="mb-2 ml-2 w-40 bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded transition"
                        >
                            Parcourir
                        </button>


                        {file && (
                            <p className="mb-2 text-sm dark:text-gray-200">
                                📄 {file.name} <FontAwesomeIcon icon={faArrowRight} />
                            </p>
                        )}

                        <button
                            onClick={handleUpload}
                            disabled={uploading}
                            className={`mb-2 ml-2 w-60 ${uploading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"} text-white font-bold py-2 px-4 rounded transition`}
                        >
                            {uploading ? "Envoi en cours..." : "Changer le fichier"} <FontAwesomeIcon icon={faArrowUp} />
                        </button>
                    </div>
                    {message ? (
                        <span className="mb-4 text-sm font-medium dark:text-gray-200 text-center">
                            {message}
                        </span>
                    ) : <span className="mb-9 text-sm font-medium dark:text-gray-200 text-center"></span>}

                </div>
            </div>

            {/* 🧩 Grille des boutons d'administration */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
                {buttons.map((btn, idx) => (
                    <button
                        key={idx}
                        onClick={() => navigate(btn.path)}
                        className={`${btn.bg} ${btn.hover} text-black font-bold rounded p-6 m-4`}
                    >
                        {btn.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
